export default __webpack_public_path__ + "static/media/OE_QuestForwardLearning_H_forLite_RGB.1866376e.svg";